import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, yupToFormErrors } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import { filter } from 'lodash';
import * as constants from '../constants';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';


const { TextArea, SelectInput, CheckboxInput, DatePickerInput, DisplayFormikState } = core;
const ButtonGroup = Button.Group;
const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    //beschrijving: Yup.string().required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class ViewChangelogForm extends Component {

    onSave = (values, { setSubmitting, setErrors }) => {
        //console.log('yep3');
        // if (this.props.onSave) {
        //     //op onderstaande manier omdat we in een dialog de boel gewoon willen sluiten en geen feedback geven (en dus geen promise returnen van parent)
        //     Promise.resolve(this.props.onSave(values)).then(() => {
        //         setSubmitting(false);
        //     })
        //         .catch(err => {
        //             setSubmitting(false);
        //             setErrors()
        //         });
        // } else {
        //     setSubmitting(false)
        // }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ViewChangelogForm', key);
    }

    CreateForm = (props) => {
       
        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                {/* <TextArea {...props} name="changes" readOnly={true} label={this.label("Changes")} formItemLayout={formItemLayout} rows={15} /> */}
                <div dangerouslySetInnerHTML={{ __html: props.values.changes }} />
                <FormItem {...tailFormItemLayout}>
                    <ButtonGroup className='entity-form-btns'>
                        <Button disabled={props.isSubmitting} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                    </ButtonGroup>
                </FormItem>

                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
            />
        );
    }
}
function mapStateToProps(state) {
    return {
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {})(ViewChangelogForm);


